class CartTypeRecommendations extends HTMLElement {
 connectedCallback() {
   this.track = this.querySelector('[data-cart-recommendation-track]');
   this.cards = [...this.querySelectorAll('[data-cart-recommendation-card]')];
   this.prev = this.querySelector('[data-cart-recommendation-prev]');
   this.next = this.querySelector('[data-cart-recommendation-next]');
   this.dots = [...this.querySelectorAll('[data-cart-recommendation-dot]')];


   if (!this.track || !this.cards.length) return;


   this.activeIndex = 0;


   this.prev?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
   this.next?.addEventListener('click', () => this.goTo(this.activeIndex + 1));


   this.dots.forEach((dot, index) => {
     dot.addEventListener('click', () => this.goTo(index));
   });


   this.track.addEventListener('scroll', () => {
     window.clearTimeout(this.scrollTimer);
     this.scrollTimer = window.setTimeout(() => this.syncFromScroll(), 60);
   }, { passive: true });


   // Delegate variant-selector events from the component itself.
   // This remains reliable even when Shopify re-renders parts of the cart drawer.
   this.addEventListener('change', this.handleVariantSelectorEvent);
   this.addEventListener('input', this.handleVariantSelectorEvent);


   this.updateControls();
 }


 disconnectedCallback() {
   window.clearTimeout(this.scrollTimer);
   this.removeEventListener('change', this.handleVariantSelectorEvent);
   this.removeEventListener('input', this.handleVariantSelectorEvent);
 }


 handleVariantSelectorEvent = (event) => {
   const select = event.target.closest?.('[data-cart-recommendation-select]');
   if (!select || !this.contains(select)) return;
   this.onVariantChange({ currentTarget: select });
 };


 goTo(index) {
   if (!this.cards.length) return;
   const nextIndex = Math.max(0, Math.min(index, this.cards.length - 1));
   const card = this.cards[nextIndex];
   if (!card) return;


   this.activeIndex = nextIndex;
   this.track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
   this.updateControls();
 }


 syncFromScroll() {
   const trackLeft = this.track.getBoundingClientRect().left;
   let closestIndex = 0;
   let closestDistance = Infinity;


   this.cards.forEach((card, index) => {
     const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
     if (distance < closestDistance) {
       closestDistance = distance;
       closestIndex = index;
     }
   });


   this.activeIndex = closestIndex;
   this.updateControls();
 }


 updateControls() {
   this.prev?.toggleAttribute('disabled', this.activeIndex <= 0);
   this.next?.toggleAttribute('disabled', this.activeIndex >= this.cards.length - 1);


   this.dots.forEach((dot, index) => {
     const active = index === this.activeIndex;
     dot.classList.toggle('is-active', active);
     dot.setAttribute('aria-current', active ? 'true' : 'false');
   });
 }


 onVariantChange(event) {
   const select = event.currentTarget;
   const option = select.options[select.selectedIndex];
   const card = select.closest('[data-cart-recommendation-card]');
   if (!card || !option) return;


   const price = card.querySelector('[data-cart-recommendation-price]');
   const comparePrice = card.querySelector('[data-cart-recommendation-compare]');
   const image = card.querySelector('[data-cart-recommendation-image]');
   const addButtonContainer = card.querySelector('add-to-cart-component');


   if (price && option.dataset.price) price.textContent = option.dataset.price;


   if (comparePrice) {
     if (option.dataset.comparePrice) {
       comparePrice.textContent = option.dataset.comparePrice;
       comparePrice.hidden = false;
     } else {
       comparePrice.textContent = '';
       comparePrice.hidden = true;
     }
   }


   if (image && option.dataset.image) {
     // Force the visible recommendation image to follow the selected main variant.
     image.removeAttribute('srcset');
     image.removeAttribute('sizes');


     // Assign through the DOM property and attribute for consistent Chrome/Safari behavior.
     image.src = option.dataset.image;
     image.setAttribute('src', option.dataset.image);
   }


   if (addButtonContainer && option.dataset.image) {
     addButtonContainer.dataset.productVariantMedia = option.dataset.image;
   }
 }
}


if (!customElements.get('cart-type-recommendations')) {
 customElements.define('cart-type-recommendations', CartTypeRecommendations);
}